import { userBase } from "../shared/base.user";

export const agencyAdminUser = [...userBase];
